// *** DO NOT EDIT THIS OBJECT MANUALLY ***
// It is generated in Python using geographical_area.generate().
//
// To re-generate, edit monoweb.django_apps.users.geographical_area, then run:
//
//     $ python -m monoweb.django_apps.users.geographical_area
//

interface AreaInfo {
  name: string;
  phonePrefix?: string;
  phoneMask?: string;
  daysToDeliver?: string;
  shippingChargeCents?: number;
  ourGovtOk?: boolean;
  theirGovtOk?: boolean;
  carrierOk?: boolean;
  cityMaxlen?: number;
  cityLabel?: string;
  cityWidth?: number;
  stateMaxlen?: number;
  stateLabel?: string;
  stateWidth?: number;
  postalCodeMaxlen?: number;
  postalCodeLabel?: string;
  postalCodeWidth?: number;
  postalCodeMask?: string;
  addressFieldOrder?: string[][];
  addressOptionalFields?: string[];
  flagFilename?: string;
  outboundShipperName?: string;
  outboundServiceName?: string;
  deliveredDutyPaid?: boolean;
  taxIdMaxlen?: number;
  taxIdLabel?: string;
  taxIdWidth?: number;
  taxIdMask?: string;
}

export const GEOGRAPHICAL_AREAS: { [key: string]: AreaInfo } = {
  AF: {
    name: `Afghanistan`,
    phonePrefix: `+93`,
    daysToDeliver: `6`,
    shippingChargeCents: 10900,
  },
  AL: {
    name: `Albania`,
    phonePrefix: `+355`,
    daysToDeliver: `9`,
    shippingChargeCents: 10900,
  },
  DZ: {
    name: `Algeria`,
    phonePrefix: `+213`,
    daysToDeliver: `11`,
    shippingChargeCents: 12200,
  },
  AS: {
    name: `American Samoa`,
    phonePrefix: `+1`,
    daysToDeliver: `6`,
    shippingChargeCents: 11600,
    cityLabel: `City`,
    cityWidth: 55,
    stateMaxlen: 2,
    stateLabel: `State`,
    stateWidth: 20,
    postalCodeLabel: `Zip Code`,
    postalCodeWidth: 25,
    postalCodeMask: `99999`,
    addressFieldOrder: [[`city`, `state`, `postalCode`]],
    addressOptionalFields: [],
    flagFilename: `US.png`,
  },
  AD: {
    name: `Andorra`,
    phonePrefix: `+376`,
    daysToDeliver: `5`,
    shippingChargeCents: 6900,
  },
  AO: {
    name: `Angola`,
    phonePrefix: `+244`,
    daysToDeliver: `6`,
    shippingChargeCents: 12200,
  },
  AI: {
    name: `Anguilla`,
    phonePrefix: `+1`,
    daysToDeliver: `5`,
    shippingChargeCents: 6600,
    cityLabel: `Town`,
    stateWidth: 0,
    postalCodeMaxlen: 8,
    postalCodeLabel: `Postcode`,
    postalCodeWidth: 100,
    addressFieldOrder: [[`city`], [`postalCode`]],
    addressOptionalFields: [],
    flagFilename: `GB.png`,
  },
  AQ: {
    name: `Antarctica`,
    carrierOk: false,
  },
  AG: {
    name: `Antigua and Barbuda`,
    phonePrefix: `+1`,
    phoneMask: `(999) 999-9999`,
    daysToDeliver: `5`,
    shippingChargeCents: 6600,
  },
  AR: {
    name: `Argentina`,
    phonePrefix: `+54`,
    daysToDeliver: `4`,
    shippingChargeCents: 8100,
  },
  AM: {
    name: `Armenia`,
    phonePrefix: `+374`,
    daysToDeliver: `6`,
    shippingChargeCents: 9000,
  },
  AW: {
    name: `Aruba`,
    phonePrefix: `+297`,
    daysToDeliver: `4`,
    shippingChargeCents: 6600,
    flagFilename: `NL.png`,
  },
  AU: {
    name: `Australia`,
    phonePrefix: `+61`,
    daysToDeliver: `12`,
    shippingChargeCents: 7900,
    cityLabel: `Suburb`,
    cityWidth: 45,
    stateMaxlen: 3,
    stateLabel: `State Code`,
    stateWidth: 30,
    postalCodeMaxlen: 6,
    postalCodeLabel: `Postcode`,
    postalCodeWidth: 25,
    addressFieldOrder: [[`city`, `state`, `postalCode`]],
    addressOptionalFields: [],
  },
  AT: {
    name: `Austria`,
    phonePrefix: `+43`,
    daysToDeliver: `4`,
    shippingChargeCents: 9300,
  },
  AZ: {
    name: `Azerbaijan`,
    phonePrefix: `+994`,
    daysToDeliver: `6`,
    shippingChargeCents: 10700,
  },
  BS: {
    name: `Bahamas`,
    phonePrefix: `+1`,
    phoneMask: `(999) 999-9999`,
    daysToDeliver: `4`,
    shippingChargeCents: 6600,
  },
  BH: {
    name: `Bahrain`,
    phonePrefix: `+973`,
    daysToDeliver: `5`,
    shippingChargeCents: 9800,
  },
  BD: {
    name: `Bangladesh`,
    phonePrefix: `+880`,
    daysToDeliver: `6`,
    shippingChargeCents: 7900,
  },
  BB: {
    name: `Barbados`,
    phonePrefix: `+1`,
    phoneMask: `(999) 999-9999`,
    daysToDeliver: `4`,
    shippingChargeCents: 6600,
  },
  BY: {
    name: `Belarus`,
    phonePrefix: `+375`,
    daysToDeliver: `7`,
    shippingChargeCents: 10700,
    ourGovtOk: false,
  },
  BE: {
    name: `Belgium`,
    phonePrefix: `+32`,
    daysToDeliver: `4`,
    shippingChargeCents: 8200,
  },
  BZ: {
    name: `Belize`,
    phonePrefix: `+501`,
    daysToDeliver: `4`,
    shippingChargeCents: 8100,
  },
  BJ: {
    name: `Benin`,
    phonePrefix: `+229`,
    daysToDeliver: `5`,
    shippingChargeCents: 12200,
  },
  BM: {
    name: `Bermuda`,
    phonePrefix: `+1`,
    daysToDeliver: `4`,
    shippingChargeCents: 6600,
    cityLabel: `Town`,
    stateWidth: 0,
    postalCodeMaxlen: 8,
    postalCodeLabel: `Postcode`,
    postalCodeWidth: 100,
    addressFieldOrder: [[`city`], [`postalCode`]],
    addressOptionalFields: [],
    flagFilename: `GB.png`,
  },
  BT: {
    name: `Bhutan`,
    phonePrefix: `+975`,
    daysToDeliver: `10`,
    shippingChargeCents: 9500,
  },
  BO: {
    name: `Bolivia`,
    phonePrefix: `+591`,
    daysToDeliver: `5`,
    shippingChargeCents: 8100,
  },
  BQ: {
    name: `Bonaire, Sint Eustatius, and Saba`,
    phonePrefix: `+599`,
    daysToDeliver: `4`,
    shippingChargeCents: 6600,
    carrierOk: false,
    flagFilename: `NL.png`,
  },
  BA: {
    name: `Bosnia and Herzegovina`,
    phonePrefix: `+387`,
    daysToDeliver: `5`,
    shippingChargeCents: 10900,
  },
  BW: {
    name: `Botswana`,
    phonePrefix: `+267`,
    daysToDeliver: `5`,
    shippingChargeCents: 12200,
  },
  BV: {
    name: `Bouvet Island`,
    daysToDeliver: `4`,
    shippingChargeCents: 9300,
    carrierOk: false,
    flagFilename: `NO.png`,
  },
  BR: {
    name: `Brazil`,
    phonePrefix: `+55`,
    daysToDeliver: `5`,
    shippingChargeCents: 8100,
    cityLabel: `City`,
    cityWidth: 80,
    stateMaxlen: 2,
    stateLabel: `State`,
    stateWidth: 20,
    postalCodeMaxlen: 9,
    postalCodeWidth: 100,
    postalCodeMask: `99999-999`,
    addressFieldOrder: [[`city`, `state`], [`postalCode`], [`taxId`]],
    addressOptionalFields: [],
    deliveredDutyPaid: true,
    taxIdMaxlen: 18,
    taxIdLabel: `Tax ID number (CPF)`,
    taxIdWidth: 100,
    taxIdMask: `999.999.999-99`,
  },
  IO: {
    name: `British Indian Ocean Territory`,
    phonePrefix: `+246`,
    daysToDeliver: `4`,
    shippingChargeCents: 9900,
    carrierOk: false,
    cityLabel: `Town`,
    stateWidth: 0,
    postalCodeMaxlen: 8,
    postalCodeLabel: `Postcode`,
    postalCodeWidth: 100,
    addressFieldOrder: [[`city`], [`postalCode`]],
    addressOptionalFields: [],
    flagFilename: `GB.png`,
  },
  BN: {
    name: `Brunei Darussalam`,
    phonePrefix: `+673`,
    daysToDeliver: `5`,
    shippingChargeCents: 10200,
  },
  BG: {
    name: `Bulgaria`,
    phonePrefix: `+359`,
    daysToDeliver: `4`,
    shippingChargeCents: 10900,
  },
  BF: {
    name: `Burkina Faso`,
    phonePrefix: `+226`,
    daysToDeliver: `5`,
    shippingChargeCents: 12200,
  },
  BI: {
    name: `Burundi`,
    phonePrefix: `+257`,
    daysToDeliver: `6`,
    shippingChargeCents: 11400,
    ourGovtOk: false,
  },
  CV: {
    name: `Cabo Verde`,
    phonePrefix: `+238`,
    daysToDeliver: `7`,
    shippingChargeCents: 11400,
  },
  KH: {
    name: `Cambodia`,
    phonePrefix: `+855`,
    daysToDeliver: `7`,
    shippingChargeCents: 10200,
  },
  CM: {
    name: `Cameroon`,
    phonePrefix: `+237`,
    daysToDeliver: `5`,
    shippingChargeCents: 12200,
  },
  CA: {
    name: `Canada`,
    phonePrefix: `+1`,
    phoneMask: `(999) 999-9999`,
    daysToDeliver: `3`,
    shippingChargeCents: 6800,
    cityLabel: `City`,
    cityWidth: 45,
    stateMaxlen: 2,
    stateLabel: `Province`,
    stateWidth: 25,
    postalCodeWidth: 30,
    postalCodeMask: `A9A 9A9`,
    addressFieldOrder: [[`city`, `state`, `postalCode`]],
    addressOptionalFields: [],
    deliveredDutyPaid: true,
  },
  KY: {
    name: `Cayman Islands`,
    phonePrefix: `+1`,
    daysToDeliver: `3`,
    shippingChargeCents: 6600,
    cityLabel: `Town`,
    stateWidth: 0,
    postalCodeMaxlen: 8,
    postalCodeLabel: `Postcode`,
    postalCodeWidth: 100,
    addressFieldOrder: [[`city`], [`postalCode`]],
    addressOptionalFields: [],
    flagFilename: `GB.png`,
  },
  CF: {
    name: `Central African Republic`,
    phonePrefix: `+236`,
    daysToDeliver: `7`,
    shippingChargeCents: 11400,
    ourGovtOk: false,
  },
  TD: {
    name: `Chad`,
    phonePrefix: `+235`,
    daysToDeliver: `7`,
    shippingChargeCents: 11400,
  },
  CL: {
    name: `Chile`,
    phonePrefix: `+56`,
    daysToDeliver: `4`,
    shippingChargeCents: 8100,
  },
  CN: {
    name: `China`,
    phonePrefix: `+86`,
    daysToDeliver: `5`,
    shippingChargeCents: 5500,
    theirGovtOk: false,
  },
  CX: {
    name: `Christmas Island`,
    phonePrefix: `+61`,
    carrierOk: false,
  },
  CC: {
    name: `Cocos (Keeling) Islands`,
    phonePrefix: `+61`,
    carrierOk: false,
  },
  CO: {
    name: `Colombia`,
    phonePrefix: `+57`,
    daysToDeliver: `4`,
    shippingChargeCents: 8100,
  },
  KM: {
    name: `Comoros`,
    phonePrefix: `+269`,
    daysToDeliver: `6`,
    shippingChargeCents: 11400,
  },
  CG: {
    name: `Congo`,
    phonePrefix: `+242`,
    daysToDeliver: `6`,
    shippingChargeCents: 12200,
  },
  CD: {
    name: `Congo (DRC)`,
    phonePrefix: `+243`,
    daysToDeliver: `6`,
    shippingChargeCents: 11400,
    ourGovtOk: false,
  },
  CK: {
    name: `Cook Islands`,
    phonePrefix: `+682`,
    daysToDeliver: `6`,
    shippingChargeCents: 9500,
    cityLabel: `Island`,
    cityWidth: 70,
    stateWidth: 0,
    postalCodeMaxlen: 4,
    postalCodeLabel: `Postcode`,
    postalCodeWidth: 30,
    addressFieldOrder: [[`city`, `postalCode`]],
    addressOptionalFields: [],
    flagFilename: `NZ.png`,
  },
  CR: {
    name: `Costa Rica`,
    phonePrefix: `+506`,
    daysToDeliver: `4`,
    shippingChargeCents: 8100,
  },
  HR: {
    name: `Croatia`,
    phonePrefix: `+385`,
    daysToDeliver: `4`,
    shippingChargeCents: 10900,
  },
  CU: {
    name: `Cuba`,
    phonePrefix: `+53`,
    ourGovtOk: false,
    carrierOk: false,
  },
  CW: {
    name: `Curaçao`,
    phonePrefix: `+599`,
    daysToDeliver: `4`,
    shippingChargeCents: 8200,
    carrierOk: false,
    flagFilename: `NL.png`,
  },
  CY: {
    name: `Cyprus`,
    phonePrefix: `+357`,
    daysToDeliver: `6`,
    shippingChargeCents: 9300,
  },
  CZ: {
    name: `Czechia`,
    phonePrefix: `+420`,
    daysToDeliver: `4`,
    shippingChargeCents: 10900,
  },
  CI: {
    name: `Côte d'Ivoire`,
    phonePrefix: `+225`,
    daysToDeliver: `6`,
    shippingChargeCents: 11400,
    ourGovtOk: false,
  },
  DK: {
    name: `Denmark`,
    phonePrefix: `+45`,
    daysToDeliver: `4`,
    shippingChargeCents: 9300,
  },
  DJ: {
    name: `Djibouti`,
    phonePrefix: `+253`,
    daysToDeliver: `6`,
    shippingChargeCents: 11400,
  },
  DM: {
    name: `Dominica`,
    phonePrefix: `+1`,
    phoneMask: `(999) 999-9999`,
    daysToDeliver: `6`,
    shippingChargeCents: 6600,
  },
  DO: {
    name: `Dominican Republic`,
    phonePrefix: `+1`,
    phoneMask: `(999) 999-9999`,
    daysToDeliver: `4`,
    shippingChargeCents: 6600,
  },
  EC: {
    name: `Ecuador`,
    phonePrefix: `+593`,
    daysToDeliver: `4`,
    shippingChargeCents: 8100,
  },
  EG: {
    name: `Egypt`,
    phonePrefix: `+20`,
    daysToDeliver: `5`,
    shippingChargeCents: 8100,
  },
  SV: {
    name: `El Salvador`,
    phonePrefix: `+503`,
    daysToDeliver: `4`,
    shippingChargeCents: 8100,
  },
  GQ: {
    name: `Equatorial Guinea`,
    phonePrefix: `+240`,
    daysToDeliver: `7`,
    shippingChargeCents: 11400,
  },
  ER: {
    name: `Eritrea`,
    phonePrefix: `+291`,
    daysToDeliver: `6`,
    shippingChargeCents: 11400,
  },
  EE: {
    name: `Estonia`,
    phonePrefix: `+372`,
    daysToDeliver: `4`,
    shippingChargeCents: 10900,
  },
  SZ: {
    name: `Eswatini`,
    phonePrefix: `+268`,
    daysToDeliver: `6`,
    shippingChargeCents: 9300,
  },
  ET: {
    name: `Ethiopia`,
    phonePrefix: `+251`,
    daysToDeliver: `5`,
    shippingChargeCents: 11400,
  },
  FK: {
    name: `Falkland Islands (Malvinas)`,
    phonePrefix: `+500`,
    daysToDeliver: `7`,
    shippingChargeCents: 7200,
    cityLabel: `Town`,
    stateWidth: 0,
    postalCodeMaxlen: 8,
    postalCodeLabel: `Postcode`,
    postalCodeWidth: 100,
    addressFieldOrder: [[`city`], [`postalCode`]],
    addressOptionalFields: [],
    flagFilename: `GB.png`,
  },
  FO: {
    name: `Faroe Islands`,
    phonePrefix: `+298`,
    daysToDeliver: `7`,
    shippingChargeCents: 6900,
    flagFilename: `DK.png`,
  },
  FJ: {
    name: `Fiji`,
    phonePrefix: `+679`,
    daysToDeliver: `7`,
    shippingChargeCents: 10200,
  },
  FI: {
    name: `Finland`,
    phonePrefix: `+358`,
    daysToDeliver: `4`,
    shippingChargeCents: 9300,
    cityLabel: `Settlement`,
    cityWidth: 70,
    stateWidth: 0,
    postalCodeMaxlen: 5,
    postalCodeWidth: 30,
    addressFieldOrder: [[`postalCode`, `city`]],
    addressOptionalFields: [],
  },
  FR: {
    name: `France`,
    phonePrefix: `+33`,
    daysToDeliver: `4`,
    shippingChargeCents: 6100,
    theirGovtOk: false,
    cityLabel: `Town Name and Sorting Code`,
    cityWidth: 70,
    stateWidth: 0,
    postalCodeMaxlen: 5,
    postalCodeWidth: 30,
    addressFieldOrder: [[`postalCode`, `city`]],
    addressOptionalFields: [],
  },
  GF: {
    name: `French Guiana`,
    phonePrefix: `+594`,
    daysToDeliver: `6`,
    shippingChargeCents: 7200,
    theirGovtOk: false,
    cityLabel: `Town Name and Sorting Code`,
    cityWidth: 70,
    stateWidth: 0,
    postalCodeMaxlen: 5,
    postalCodeWidth: 30,
    addressFieldOrder: [[`postalCode`, `city`]],
    addressOptionalFields: [],
    flagFilename: `FR.png`,
  },
  PF: {
    name: `French Polynesia`,
    phonePrefix: `+689`,
    daysToDeliver: `4`,
    shippingChargeCents: 10200,
    theirGovtOk: false,
    carrierOk: false,
    cityLabel: `Town Name and Sorting Code`,
    cityWidth: 70,
    stateWidth: 0,
    postalCodeMaxlen: 5,
    postalCodeWidth: 30,
    addressFieldOrder: [[`postalCode`, `city`]],
    addressOptionalFields: [],
    flagFilename: `FR.png`,
  },
  TF: {
    name: `French Southern Territories`,
    daysToDeliver: `4`,
    shippingChargeCents: 6100,
    theirGovtOk: false,
    carrierOk: false,
    cityLabel: `Town Name and Sorting Code`,
    cityWidth: 70,
    stateWidth: 0,
    postalCodeMaxlen: 5,
    postalCodeWidth: 30,
    addressFieldOrder: [[`postalCode`, `city`]],
    addressOptionalFields: [],
    flagFilename: `FR.png`,
  },
  GA: {
    name: `Gabon`,
    phonePrefix: `+241`,
    daysToDeliver: `5`,
    shippingChargeCents: 12200,
  },
  GM: {
    name: `Gambia`,
    phonePrefix: `+220`,
    daysToDeliver: `6`,
    shippingChargeCents: 12200,
  },
  GE: {
    name: `Georgia`,
    phonePrefix: `+995`,
    daysToDeliver: `8`,
    shippingChargeCents: 10700,
  },
  DE: {
    name: `Germany`,
    phonePrefix: `+49`,
    daysToDeliver: `4`,
    shippingChargeCents: 8200,
    theirGovtOk: false,
    cityLabel: `Settlement`,
    cityWidth: 80,
    stateWidth: 0,
    postalCodeMaxlen: 5,
    postalCodeWidth: 20,
    addressFieldOrder: [[`postalCode`, `city`]],
    addressOptionalFields: [],
  },
  GH: {
    name: `Ghana`,
    phonePrefix: `+233`,
    daysToDeliver: `6`,
    shippingChargeCents: 12200,
  },
  GI: {
    name: `Gibraltar`,
    phonePrefix: `+350`,
    daysToDeliver: `5`,
    shippingChargeCents: 6900,
    cityLabel: `Town`,
    stateWidth: 0,
    postalCodeMaxlen: 8,
    postalCodeLabel: `Postcode`,
    postalCodeWidth: 100,
    addressFieldOrder: [[`city`], [`postalCode`]],
    addressOptionalFields: [],
    flagFilename: `GB.png`,
  },
  GR: {
    name: `Greece`,
    phonePrefix: `+30`,
    daysToDeliver: `4`,
    shippingChargeCents: 9300,
  },
  GL: {
    name: `Greenland`,
    phonePrefix: `+299`,
    daysToDeliver: `8`,
    shippingChargeCents: 6900,
    flagFilename: `DK.png`,
  },
  GD: {
    name: `Grenada`,
    phonePrefix: `+1`,
    phoneMask: `(999) 999-9999`,
    daysToDeliver: `5`,
    shippingChargeCents: 6600,
  },
  GP: {
    name: `Guadeloupe`,
    phonePrefix: `+590`,
    daysToDeliver: `4`,
    shippingChargeCents: 6300,
    theirGovtOk: false,
    cityLabel: `Town Name and Sorting Code`,
    cityWidth: 70,
    stateWidth: 0,
    postalCodeMaxlen: 5,
    postalCodeWidth: 30,
    addressFieldOrder: [[`postalCode`, `city`]],
    addressOptionalFields: [],
    flagFilename: `FR.png`,
  },
  GU: {
    name: `Guam`,
    phonePrefix: `+1`,
    daysToDeliver: `4`,
    shippingChargeCents: 9200,
    cityLabel: `City`,
    cityWidth: 55,
    stateMaxlen: 2,
    stateLabel: `State`,
    stateWidth: 20,
    postalCodeLabel: `Zip Code`,
    postalCodeWidth: 25,
    postalCodeMask: `99999`,
    addressFieldOrder: [[`city`, `state`, `postalCode`]],
    addressOptionalFields: [],
    flagFilename: `US.png`,
  },
  GT: {
    name: `Guatemala`,
    phonePrefix: `+502`,
    daysToDeliver: `4`,
    shippingChargeCents: 8100,
  },
  GG: {
    name: `Guernsey`,
    phonePrefix: `+44`,
    daysToDeliver: `5`,
    shippingChargeCents: 6900,
    cityLabel: `Town`,
    stateWidth: 0,
    postalCodeMaxlen: 8,
    postalCodeLabel: `Postcode`,
    postalCodeWidth: 100,
    addressFieldOrder: [[`city`], [`postalCode`]],
    addressOptionalFields: [],
    flagFilename: `GB.png`,
  },
  GN: {
    name: `Guinea`,
    phonePrefix: `+224`,
    daysToDeliver: `6`,
    shippingChargeCents: 12200,
  },
  GW: {
    name: `Guinea Bissau`,
    phonePrefix: `+245`,
    daysToDeliver: `6`,
    shippingChargeCents: 11400,
  },
  GY: {
    name: `Guyana`,
    phonePrefix: `+592`,
    daysToDeliver: `6`,
    shippingChargeCents: 8100,
  },
  HT: {
    name: `Haiti`,
    phonePrefix: `+509`,
    daysToDeliver: `4`,
    shippingChargeCents: 6600,
  },
  HM: {
    name: `Heard Island and McDonald Islands`,
    daysToDeliver: `12`,
    shippingChargeCents: 7900,
    carrierOk: false,
    cityLabel: `Suburb`,
    cityWidth: 45,
    stateMaxlen: 3,
    stateLabel: `State Code`,
    stateWidth: 30,
    postalCodeMaxlen: 6,
    postalCodeLabel: `Postcode`,
    postalCodeWidth: 25,
    addressFieldOrder: [[`city`, `state`, `postalCode`]],
    addressOptionalFields: [],
    flagFilename: `AU.png`,
  },
  VA: {
    name: `Holy See (Vatican City State)`,
    phonePrefix: `+379`,
    daysToDeliver: `4`,
    shippingChargeCents: 6100,
    carrierOk: false,
  },
  HN: {
    name: `Honduras`,
    phonePrefix: `+504`,
    daysToDeliver: `4`,
    shippingChargeCents: 8100,
  },
  HK: {
    name: `Hong Kong`,
    phonePrefix: `+852`,
    daysToDeliver: `4`,
    shippingChargeCents: 7100,
    cityLabel: `Village, Town, or District`,
    stateMaxlen: 15,
    stateLabel: `Part of Hong Kong`,
    stateWidth: 40,
    postalCodeWidth: 0,
    addressFieldOrder: [[`city`], [`state`]],
    addressOptionalFields: [],
  },
  HU: {
    name: `Hungary`,
    phonePrefix: `+36`,
    daysToDeliver: `4`,
    shippingChargeCents: 10900,
  },
  IS: {
    name: `Iceland`,
    phonePrefix: `+354`,
    daysToDeliver: `4`,
    shippingChargeCents: 9300,
  },
  IN: {
    name: `India`,
    phonePrefix: `+91`,
    daysToDeliver: `5`,
    shippingChargeCents: 5800,
    theirGovtOk: false,
  },
  ID: {
    name: `Indonesia`,
    phonePrefix: `+62`,
    daysToDeliver: `5`,
    shippingChargeCents: 7900,
  },
  IR: {
    name: `Iran`,
    phonePrefix: `+98`,
    ourGovtOk: false,
    carrierOk: false,
  },
  IQ: {
    name: `Iraq`,
    phonePrefix: `+964`,
    daysToDeliver: `5`,
    shippingChargeCents: 9000,
    ourGovtOk: false,
  },
  IE: {
    name: `Ireland`,
    phonePrefix: `+353`,
    daysToDeliver: `4`,
    shippingChargeCents: 8200,
    cityLabel: `Postal Town`,
    stateWidth: 0,
    postalCodeMaxlen: 8,
    postalCodeWidth: 30,
    addressFieldOrder: [[`city`], [`postalCode`]],
    addressOptionalFields: [],
  },
  IM: {
    name: `Isle of Man`,
    phonePrefix: `+44`,
    daysToDeliver: `4`,
    shippingChargeCents: 9900,
    carrierOk: false,
    cityLabel: `Town`,
    stateWidth: 0,
    postalCodeMaxlen: 8,
    postalCodeLabel: `Postcode`,
    postalCodeWidth: 100,
    addressFieldOrder: [[`city`], [`postalCode`]],
    addressOptionalFields: [],
    flagFilename: `GB.png`,
  },
  IL: {
    name: `Israel`,
    phonePrefix: `+972`,
    daysToDeliver: `4`,
    shippingChargeCents: 9800,
    cityLabel: `City`,
    cityWidth: 70,
    stateWidth: 0,
    postalCodeMaxlen: 7,
    postalCodeWidth: 30,
    addressFieldOrder: [[`postalCode`, `city`]],
    addressOptionalFields: [],
  },
  IT: {
    name: `Italy`,
    phonePrefix: `+39`,
    daysToDeliver: `4`,
    shippingChargeCents: 8200,
    cityLabel: `Town`,
    cityWidth: 45,
    stateMaxlen: 2,
    stateLabel: `Province`,
    stateWidth: 25,
    postalCodeMaxlen: 5,
    postalCodeWidth: 30,
    addressFieldOrder: [[`postalCode`, `city`, `state`]],
    addressOptionalFields: [],
  },
  JM: {
    name: `Jamaica`,
    phonePrefix: `+1`,
    phoneMask: `(999) 999-9999`,
    daysToDeliver: `4`,
    shippingChargeCents: 6600,
  },
  JP: {
    name: `Japan`,
    phonePrefix: `+81`,
    daysToDeliver: `4`,
    shippingChargeCents: 8300,
  },
  JE: {
    name: `Jersey`,
    phonePrefix: `+44`,
    daysToDeliver: `5`,
    shippingChargeCents: 6900,
    cityLabel: `Town`,
    stateWidth: 0,
    postalCodeMaxlen: 8,
    postalCodeLabel: `Postcode`,
    postalCodeWidth: 100,
    addressFieldOrder: [[`city`], [`postalCode`]],
    addressOptionalFields: [],
    flagFilename: `GB.png`,
  },
  JO: {
    name: `Jordan`,
    phonePrefix: `+962`,
    daysToDeliver: `6`,
    shippingChargeCents: 9800,
  },
  KZ: {
    name: `Kazakhstan`,
    phonePrefix: `+7`,
    daysToDeliver: `6`,
    shippingChargeCents: 10900,
  },
  KE: {
    name: `Kenya`,
    phonePrefix: `+254`,
    daysToDeliver: `5`,
    shippingChargeCents: 11400,
  },
  KI: {
    name: `Kiribati`,
    phonePrefix: `+686`,
    daysToDeliver: `8`,
    shippingChargeCents: 10200,
  },
  XK: {
    name: `Kosovo`,
    phonePrefix: `+383`,
    carrierOk: false,
  },
  KW: {
    name: `Kuwait`,
    phonePrefix: `+965`,
    daysToDeliver: `6`,
    shippingChargeCents: 9800,
  },
  KG: {
    name: `Kyrgyzstan`,
    phonePrefix: `+996`,
    daysToDeliver: `7`,
    shippingChargeCents: 10700,
  },
  LA: {
    name: `Laos`,
    phonePrefix: `+856`,
    daysToDeliver: `7`,
    shippingChargeCents: 10200,
  },
  LV: {
    name: `Latvia`,
    phonePrefix: `+371`,
    daysToDeliver: `4`,
    shippingChargeCents: 10900,
  },
  LB: {
    name: `Lebanon`,
    phonePrefix: `+961`,
    daysToDeliver: `5`,
    shippingChargeCents: 9000,
    ourGovtOk: false,
  },
  LS: {
    name: `Lesotho`,
    phonePrefix: `+266`,
    daysToDeliver: `5`,
    shippingChargeCents: 11400,
  },
  LR: {
    name: `Liberia`,
    phonePrefix: `+231`,
    daysToDeliver: `6`,
    shippingChargeCents: 12200,
  },
  LY: {
    name: `Libya`,
    phonePrefix: `+218`,
    daysToDeliver: `7`,
    shippingChargeCents: 11400,
    ourGovtOk: false,
  },
  LI: {
    name: `Liechtenstein`,
    phonePrefix: `+423`,
    daysToDeliver: `5`,
    shippingChargeCents: 6900,
  },
  LT: {
    name: `Lithuania`,
    phonePrefix: `+370`,
    daysToDeliver: `5`,
    shippingChargeCents: 10900,
  },
  LU: {
    name: `Luxembourg`,
    phonePrefix: `+352`,
    daysToDeliver: `4`,
    shippingChargeCents: 8200,
  },
  MO: {
    name: `Macau`,
    phonePrefix: `+853`,
    daysToDeliver: `5`,
    shippingChargeCents: 5800,
    theirGovtOk: false,
    flagFilename: `CN.png`,
  },
  MG: {
    name: `Madagascar`,
    phonePrefix: `+261`,
    daysToDeliver: `6`,
    shippingChargeCents: 12200,
  },
  MW: {
    name: `Malawi`,
    phonePrefix: `+265`,
    daysToDeliver: `6`,
    shippingChargeCents: 12200,
  },
  MY: {
    name: `Malaysia`,
    phonePrefix: `+60`,
    daysToDeliver: `5`,
    shippingChargeCents: 7900,
  },
  MV: {
    name: `Maldives`,
    phonePrefix: `+960`,
    daysToDeliver: `7`,
    shippingChargeCents: 10200,
  },
  ML: {
    name: `Mali`,
    phonePrefix: `+223`,
    daysToDeliver: `5`,
    shippingChargeCents: 12200,
  },
  MT: {
    name: `Malta`,
    phonePrefix: `+356`,
    daysToDeliver: `5`,
    shippingChargeCents: 9300,
  },
  MH: {
    name: `Marshall Islands`,
    phonePrefix: `+692`,
    carrierOk: false,
  },
  MQ: {
    name: `Martinique`,
    phonePrefix: `+596`,
    daysToDeliver: `4`,
    shippingChargeCents: 6300,
    theirGovtOk: false,
    cityLabel: `Town Name and Sorting Code`,
    cityWidth: 70,
    stateWidth: 0,
    postalCodeMaxlen: 5,
    postalCodeWidth: 30,
    addressFieldOrder: [[`postalCode`, `city`]],
    addressOptionalFields: [],
    flagFilename: `FR.png`,
  },
  MR: {
    name: `Mauritania`,
    phonePrefix: `+222`,
    daysToDeliver: `6`,
    shippingChargeCents: 11400,
  },
  MU: {
    name: `Mauritius`,
    phonePrefix: `+230`,
    daysToDeliver: `5`,
    shippingChargeCents: 12200,
  },
  YT: {
    name: `Mayotte`,
    phonePrefix: `+262`,
    daysToDeliver: `4`,
    shippingChargeCents: 11400,
    theirGovtOk: false,
    cityLabel: `Town Name and Sorting Code`,
    cityWidth: 70,
    stateWidth: 0,
    postalCodeMaxlen: 5,
    postalCodeWidth: 30,
    addressFieldOrder: [[`postalCode`, `city`]],
    addressOptionalFields: [],
    flagFilename: `FR.png`,
  },
  MX: {
    name: `Mexico`,
    phonePrefix: `+52`,
    daysToDeliver: `4`,
    shippingChargeCents: 4500,
    cityLabel: `Settlement`,
    cityWidth: 50,
    stateMaxlen: 5,
    stateLabel: `State`,
    stateWidth: 20,
    postalCodeMaxlen: 5,
    postalCodeWidth: 30,
    postalCodeMask: `99999`,
    addressFieldOrder: [[`postalCode`, `city`, `state`]],
    addressOptionalFields: [],
  },
  FM: {
    name: `Micronesia`,
    phonePrefix: `+691`,
    carrierOk: false,
  },
  MD: {
    name: `Moldova`,
    phonePrefix: `+373`,
    daysToDeliver: `6`,
    shippingChargeCents: 10700,
  },
  MC: {
    name: `Monaco`,
    phonePrefix: `+377`,
    daysToDeliver: `5`,
    shippingChargeCents: 6100,
  },
  MN: {
    name: `Mongolia`,
    phonePrefix: `+976`,
    daysToDeliver: `9`,
    shippingChargeCents: 10200,
  },
  ME: {
    name: `Montenegro`,
    phonePrefix: `+382`,
    daysToDeliver: `6`,
    shippingChargeCents: 10900,
  },
  MS: {
    name: `Montserrat`,
    phonePrefix: `+1`,
    daysToDeliver: `5`,
    shippingChargeCents: 6600,
    cityLabel: `Town`,
    stateWidth: 0,
    postalCodeMaxlen: 8,
    postalCodeLabel: `Postcode`,
    postalCodeWidth: 100,
    addressFieldOrder: [[`city`], [`postalCode`]],
    addressOptionalFields: [],
    flagFilename: `GB.png`,
  },
  MA: {
    name: `Morocco`,
    phonePrefix: `+212`,
    daysToDeliver: `4`,
    shippingChargeCents: 12200,
  },
  MZ: {
    name: `Mozambique`,
    phonePrefix: `+258`,
    daysToDeliver: `6`,
    shippingChargeCents: 12200,
  },
  MM: {
    name: `Myanmar`,
    phonePrefix: `+95`,
    ourGovtOk: false,
    carrierOk: false,
  },
  NA: {
    name: `Namibia`,
    phonePrefix: `+264`,
    daysToDeliver: `5`,
    shippingChargeCents: 12200,
  },
  NR: {
    name: `Nauru`,
    phonePrefix: `+674`,
    daysToDeliver: `7`,
    shippingChargeCents: 10200,
  },
  NP: {
    name: `Nepal`,
    phonePrefix: `+977`,
    daysToDeliver: `7`,
    shippingChargeCents: 10200,
  },
  NL: {
    name: `Netherlands`,
    phonePrefix: `+31`,
    daysToDeliver: `4`,
    shippingChargeCents: 8200,
  },
  NC: {
    name: `New Caledonia`,
    phonePrefix: `+687`,
    daysToDeliver: `7`,
    shippingChargeCents: 9500,
    theirGovtOk: false,
    cityLabel: `Town Name and Sorting Code`,
    cityWidth: 70,
    stateWidth: 0,
    postalCodeMaxlen: 5,
    postalCodeWidth: 30,
    addressFieldOrder: [[`postalCode`, `city`]],
    addressOptionalFields: [],
    flagFilename: `FR.png`,
  },
  NZ: {
    name: `New Zealand`,
    phonePrefix: `+64`,
    daysToDeliver: `5`,
    shippingChargeCents: 7900,
    cityLabel: `Settlement`,
    cityWidth: 70,
    stateWidth: 0,
    postalCodeMaxlen: 4,
    postalCodeLabel: `Postcode`,
    postalCodeWidth: 30,
    addressFieldOrder: [[`city`, `postalCode`]],
    addressOptionalFields: [],
  },
  NI: {
    name: `Nicaragua`,
    phonePrefix: `+505`,
    daysToDeliver: `4`,
    shippingChargeCents: 8100,
  },
  NE: {
    name: `Niger`,
    phonePrefix: `+227`,
    daysToDeliver: `7`,
    shippingChargeCents: 11400,
  },
  NG: {
    name: `Nigeria`,
    phonePrefix: `+234`,
    daysToDeliver: `5`,
    shippingChargeCents: 12200,
  },
  NU: {
    name: `Niue`,
    phonePrefix: `+683`,
    daysToDeliver: `7`,
    shippingChargeCents: 10200,
    cityLabel: `Settlement`,
    cityWidth: 70,
    stateWidth: 0,
    postalCodeMaxlen: 4,
    postalCodeLabel: `Postcode`,
    postalCodeWidth: 30,
    addressFieldOrder: [[`city`, `postalCode`]],
    addressOptionalFields: [],
    flagFilename: `NZ.png`,
  },
  NF: {
    name: `Norfolk Island`,
    phonePrefix: `+672`,
    daysToDeliver: `12`,
    shippingChargeCents: 7900,
    carrierOk: false,
    cityLabel: `Suburb`,
    cityWidth: 45,
    stateMaxlen: 3,
    stateLabel: `State Code`,
    stateWidth: 30,
    postalCodeMaxlen: 6,
    postalCodeLabel: `Postcode`,
    postalCodeWidth: 25,
    addressFieldOrder: [[`city`, `state`, `postalCode`]],
    addressOptionalFields: [],
    flagFilename: `AU.png`,
  },
  KP: {
    name: `North Korea`,
    phonePrefix: `+850`,
    ourGovtOk: false,
    carrierOk: false,
  },
  MK: {
    name: `North Macedonia`,
    phonePrefix: `+389`,
    daysToDeliver: `5`,
    shippingChargeCents: 7900,
  },
  MP: {
    name: `Northern Mariana Islands`,
    phonePrefix: `+1`,
    daysToDeliver: `2-6`,
    shippingChargeCents: 995,
    carrierOk: false,
    cityLabel: `City`,
    cityWidth: 55,
    stateMaxlen: 2,
    stateLabel: `State`,
    stateWidth: 20,
    postalCodeLabel: `Zip Code`,
    postalCodeWidth: 25,
    postalCodeMask: `99999`,
    addressFieldOrder: [[`city`, `state`, `postalCode`]],
    addressOptionalFields: [],
    flagFilename: `US.png`,
    outboundShipperName: `USPS`,
    outboundServiceName: `First-class Mail`,
  },
  NO: {
    name: `Norway`,
    phonePrefix: `+47`,
    daysToDeliver: `4`,
    shippingChargeCents: 9300,
  },
  OM: {
    name: `Oman`,
    phonePrefix: `+968`,
    daysToDeliver: `5`,
    shippingChargeCents: 9800,
  },
  PK: {
    name: `Pakistan`,
    phonePrefix: `+92`,
    daysToDeliver: `6`,
    shippingChargeCents: 9800,
  },
  PW: {
    name: `Palau`,
    phonePrefix: `+680`,
    carrierOk: false,
  },
  PS: {
    name: `Palestine`,
    phonePrefix: `+970`,
    carrierOk: false,
  },
  PA: {
    name: `Panama`,
    phonePrefix: `+507`,
    daysToDeliver: `4`,
    shippingChargeCents: 8100,
  },
  PG: {
    name: `Papua New Guinea`,
    phonePrefix: `+675`,
    daysToDeliver: `7`,
    shippingChargeCents: 10200,
  },
  PY: {
    name: `Paraguay`,
    phonePrefix: `+595`,
    daysToDeliver: `5`,
    shippingChargeCents: 8100,
  },
  PE: {
    name: `Peru`,
    phonePrefix: `+51`,
    daysToDeliver: `5`,
    shippingChargeCents: 8100,
  },
  PH: {
    name: `Philippines`,
    phonePrefix: `+63`,
    daysToDeliver: `5`,
    shippingChargeCents: 7900,
  },
  PN: {
    name: `Pitcairn`,
    phonePrefix: `+64`,
    daysToDeliver: `4`,
    shippingChargeCents: 9900,
    carrierOk: false,
    cityLabel: `Town`,
    stateWidth: 0,
    postalCodeMaxlen: 8,
    postalCodeLabel: `Postcode`,
    postalCodeWidth: 100,
    addressFieldOrder: [[`city`], [`postalCode`]],
    addressOptionalFields: [],
    flagFilename: `GB.png`,
  },
  PL: {
    name: `Poland`,
    phonePrefix: `+48`,
    daysToDeliver: `4`,
    shippingChargeCents: 10900,
  },
  PT: {
    name: `Portugal`,
    phonePrefix: `+351`,
    daysToDeliver: `4`,
    shippingChargeCents: 8200,
  },
  PR: {
    name: `Puerto Rico`,
    phonePrefix: `+1`,
    daysToDeliver: `2-6`,
    shippingChargeCents: 995,
    cityLabel: `City`,
    cityWidth: 55,
    stateMaxlen: 2,
    stateLabel: `State`,
    stateWidth: 20,
    postalCodeLabel: `Zip Code`,
    postalCodeWidth: 25,
    postalCodeMask: `99999`,
    addressFieldOrder: [[`city`, `state`, `postalCode`]],
    addressOptionalFields: [],
    flagFilename: `US.png`,
    outboundShipperName: `USPS`,
    outboundServiceName: `First-class Mail`,
  },
  QA: {
    name: `Qatar`,
    phonePrefix: `+974`,
    daysToDeliver: `5`,
    shippingChargeCents: 9800,
  },
  RO: {
    name: `Romania`,
    phonePrefix: `+40`,
    daysToDeliver: `5`,
    shippingChargeCents: 10900,
  },
  RU: {
    name: `Russian Federation`,
    phonePrefix: `+7`,
    daysToDeliver: `6`,
    shippingChargeCents: 10700,
    theirGovtOk: false,
  },
  RW: {
    name: `Rwanda`,
    phonePrefix: `+250`,
    daysToDeliver: `5`,
    shippingChargeCents: 11400,
  },
  RE: {
    name: `Réunion`,
    phonePrefix: `+262`,
    daysToDeliver: `4`,
    shippingChargeCents: 11400,
    theirGovtOk: false,
    cityLabel: `Town Name and Sorting Code`,
    cityWidth: 70,
    stateWidth: 0,
    postalCodeMaxlen: 5,
    postalCodeWidth: 30,
    addressFieldOrder: [[`postalCode`, `city`]],
    addressOptionalFields: [],
    flagFilename: `FR.png`,
  },
  BL: {
    name: `Saint Barthélemy`,
    phonePrefix: `+590`,
    daysToDeliver: `4`,
    shippingChargeCents: 6600,
    theirGovtOk: false,
    carrierOk: false,
    cityLabel: `Town Name and Sorting Code`,
    cityWidth: 70,
    stateWidth: 0,
    postalCodeMaxlen: 5,
    postalCodeWidth: 30,
    addressFieldOrder: [[`postalCode`, `city`]],
    addressOptionalFields: [],
    flagFilename: `FR.png`,
  },
  SH: {
    name: `Saint Helena, Ascension and Tristan da Cunha`,
    phonePrefix: `+290`,
    daysToDeliver: `4`,
    shippingChargeCents: 9900,
    carrierOk: false,
    cityLabel: `Town`,
    stateWidth: 0,
    postalCodeMaxlen: 8,
    postalCodeLabel: `Postcode`,
    postalCodeWidth: 100,
    addressFieldOrder: [[`city`], [`postalCode`]],
    addressOptionalFields: [],
    flagFilename: `GB.png`,
  },
  KN: {
    name: `Saint Kitts and Nevis`,
    phonePrefix: `+1`,
    phoneMask: `(999) 999-9999`,
    daysToDeliver: `5`,
    shippingChargeCents: 6600,
  },
  LC: {
    name: `Saint Lucia`,
    phonePrefix: `+1`,
    phoneMask: `(999) 999-9999`,
    daysToDeliver: `5`,
    shippingChargeCents: 6600,
  },
  MF: {
    name: `Saint Martin (French part)`,
    phonePrefix: `+590`,
    daysToDeliver: `4`,
    shippingChargeCents: 6100,
    theirGovtOk: false,
    carrierOk: false,
    cityLabel: `Town Name and Sorting Code`,
    cityWidth: 70,
    stateWidth: 0,
    postalCodeMaxlen: 5,
    postalCodeWidth: 30,
    addressFieldOrder: [[`postalCode`, `city`]],
    addressOptionalFields: [],
    flagFilename: `FR.png`,
  },
  PM: {
    name: `Saint Pierre and Miquelon`,
    phonePrefix: `+508`,
    daysToDeliver: `4`,
    shippingChargeCents: 6100,
    theirGovtOk: false,
    carrierOk: false,
    cityLabel: `Town Name and Sorting Code`,
    cityWidth: 70,
    stateWidth: 0,
    postalCodeMaxlen: 5,
    postalCodeWidth: 30,
    addressFieldOrder: [[`postalCode`, `city`]],
    addressOptionalFields: [],
    flagFilename: `FR.png`,
  },
  VC: {
    name: `Saint Vincent and the Grenadines`,
    phonePrefix: `+1`,
    phoneMask: `(999) 999-9999`,
    daysToDeliver: `5`,
    shippingChargeCents: 6600,
  },
  WS: {
    name: `Samoa`,
    phonePrefix: `+685`,
    daysToDeliver: `6`,
    shippingChargeCents: 10200,
  },
  SM: {
    name: `San Marino`,
    phonePrefix: `+378`,
    daysToDeliver: `5`,
    shippingChargeCents: 6100,
  },
  ST: {
    name: `Sao Tome and Principe`,
    phonePrefix: `+239`,
    daysToDeliver: `8`,
    shippingChargeCents: 11400,
  },
  SA: {
    name: `Saudi Arabia`,
    phonePrefix: `+966`,
    daysToDeliver: `4`,
    shippingChargeCents: 9000,
  },
  SN: {
    name: `Senegal`,
    phonePrefix: `+221`,
    daysToDeliver: `5`,
    shippingChargeCents: 12200,
  },
  RS: {
    name: `Serbia`,
    phonePrefix: `+381`,
    daysToDeliver: `4`,
    shippingChargeCents: 10900,
  },
  SC: {
    name: `Seychelles`,
    phonePrefix: `+248`,
    daysToDeliver: `4`,
    shippingChargeCents: 12200,
  },
  SL: {
    name: `Sierra Leone`,
    phonePrefix: `+232`,
    daysToDeliver: `6`,
    shippingChargeCents: 11400,
  },
  SG: {
    name: `Singapore`,
    phonePrefix: `+65`,
    daysToDeliver: `5`,
    shippingChargeCents: 7100,
    cityLabel: `City`,
    cityWidth: 70,
    stateWidth: 0,
    postalCodeMaxlen: 6,
    postalCodeWidth: 30,
    addressFieldOrder: [[`city`, `postalCode`]],
    addressOptionalFields: [],
  },
  SX: {
    name: `Sint Maarten (Dutch part)`,
    phonePrefix: `+1`,
    phoneMask: `(999) 999-9999`,
    daysToDeliver: `4`,
    shippingChargeCents: 6600,
    carrierOk: false,
    flagFilename: `NL.png`,
  },
  SK: {
    name: `Slovakia`,
    phonePrefix: `+421`,
    daysToDeliver: `4`,
    shippingChargeCents: 10900,
  },
  SI: {
    name: `Slovenia`,
    phonePrefix: `+386`,
    daysToDeliver: `4`,
    shippingChargeCents: 10900,
  },
  SB: {
    name: `Solomon Islands`,
    phonePrefix: `+677`,
    daysToDeliver: `6`,
    shippingChargeCents: 10200,
  },
  SO: {
    name: `Somalia`,
    phonePrefix: `+252`,
    ourGovtOk: false,
    carrierOk: false,
  },
  ZA: {
    name: `South Africa`,
    phonePrefix: `+27`,
    daysToDeliver: `5`,
    shippingChargeCents: 12200,
  },
  GS: {
    name: `South Georgia and the South Sandwich Islands`,
    phonePrefix: `+500`,
    daysToDeliver: `4`,
    shippingChargeCents: 9900,
    carrierOk: false,
    cityLabel: `Town`,
    stateWidth: 0,
    postalCodeMaxlen: 8,
    postalCodeLabel: `Postcode`,
    postalCodeWidth: 100,
    addressFieldOrder: [[`city`], [`postalCode`]],
    addressOptionalFields: [],
    flagFilename: `GB.png`,
  },
  KR: {
    name: `South Korea`,
    phonePrefix: `+82`,
    daysToDeliver: `8`,
    shippingChargeCents: 7800,
    theirGovtOk: false,
  },
  SS: {
    name: `South Sudan`,
    phonePrefix: `+211`,
    ourGovtOk: false,
    carrierOk: false,
  },
  ES: {
    name: `Spain`,
    phonePrefix: `+34`,
    daysToDeliver: `4`,
    shippingChargeCents: 8200,
    cityLabel: `Town`,
    cityWidth: 40,
    stateMaxlen: 30,
    stateLabel: `Province`,
    stateWidth: 30,
    postalCodeMaxlen: 5,
    postalCodeWidth: 30,
    addressFieldOrder: [[`postalCode`, `city`, `state`]],
    addressOptionalFields: [`state`],
  },
  LK: {
    name: `Sri Lanka`,
    phonePrefix: `+94`,
    daysToDeliver: `5`,
    shippingChargeCents: 7900,
  },
  SD: {
    name: `Sudan`,
    phonePrefix: `+249`,
    ourGovtOk: false,
    carrierOk: false,
  },
  SR: {
    name: `Suriname`,
    phonePrefix: `+597`,
    daysToDeliver: `7`,
    shippingChargeCents: 8100,
  },
  SJ: {
    name: `Svalbard and Jan Mayen`,
    phonePrefix: `+47`,
    daysToDeliver: `4`,
    shippingChargeCents: 9300,
    carrierOk: false,
    flagFilename: `NO.png`,
  },
  SE: {
    name: `Sweden`,
    phonePrefix: `+46`,
    daysToDeliver: `4`,
    shippingChargeCents: 9300,
  },
  CH: {
    name: `Switzerland`,
    phonePrefix: `+41`,
    daysToDeliver: `4`,
    shippingChargeCents: 9300,
  },
  SY: {
    name: `Syria`,
    phonePrefix: `+963`,
    ourGovtOk: false,
    carrierOk: false,
  },
  TW: {
    name: `Taiwan`,
    phonePrefix: `+886`,
    daysToDeliver: `4`,
    shippingChargeCents: 7100,
  },
  TJ: {
    name: `Tajikistan`,
    phonePrefix: `+992`,
    daysToDeliver: `7`,
    shippingChargeCents: 10700,
  },
  TZ: {
    name: `Tanzania`,
    phonePrefix: `+255`,
    daysToDeliver: `5`,
    shippingChargeCents: 12200,
  },
  TH: {
    name: `Thailand`,
    phonePrefix: `+66`,
    daysToDeliver: `5`,
    shippingChargeCents: 7900,
  },
  TL: {
    name: `Timor-Leste`,
    phonePrefix: `+670`,
    daysToDeliver: `10`,
    shippingChargeCents: 9500,
  },
  TG: {
    name: `Togo`,
    phonePrefix: `+228`,
    daysToDeliver: `5`,
    shippingChargeCents: 12200,
  },
  TK: {
    name: `Tokelau`,
    phonePrefix: `+690`,
    daysToDeliver: `5`,
    shippingChargeCents: 7900,
    carrierOk: false,
    cityLabel: `Settlement`,
    cityWidth: 70,
    stateWidth: 0,
    postalCodeMaxlen: 4,
    postalCodeLabel: `Postcode`,
    postalCodeWidth: 30,
    addressFieldOrder: [[`city`, `postalCode`]],
    addressOptionalFields: [],
    flagFilename: `NZ.png`,
  },
  TO: {
    name: `Tonga`,
    phonePrefix: `+676`,
    daysToDeliver: `7`,
    shippingChargeCents: 10200,
  },
  TT: {
    name: `Trinidad and Tobago`,
    phonePrefix: `+1`,
    phoneMask: `(999) 999-9999`,
    daysToDeliver: `4`,
    shippingChargeCents: 6600,
  },
  TN: {
    name: `Tunisia`,
    phonePrefix: `+216`,
    daysToDeliver: `6`,
    shippingChargeCents: 11400,
  },
  TM: {
    name: `Turkmenistan`,
    phonePrefix: `+993`,
    carrierOk: false,
  },
  TC: {
    name: `Turks and Caicos Islands`,
    phonePrefix: `+1`,
    daysToDeliver: `4`,
    shippingChargeCents: 6600,
    cityLabel: `Town`,
    stateWidth: 0,
    postalCodeMaxlen: 8,
    postalCodeLabel: `Postcode`,
    postalCodeWidth: 100,
    addressFieldOrder: [[`city`], [`postalCode`]],
    addressOptionalFields: [],
    flagFilename: `GB.png`,
  },
  TV: {
    name: `Tuvalu`,
    phonePrefix: `+688`,
    daysToDeliver: `7`,
    shippingChargeCents: 10200,
  },
  TR: {
    name: `Türkiye`,
    phonePrefix: `+90`,
    daysToDeliver: `4`,
    shippingChargeCents: 9800,
  },
  UG: {
    name: `Uganda`,
    phonePrefix: `+256`,
    daysToDeliver: `5`,
    shippingChargeCents: 12200,
  },
  UA: {
    name: `Ukraine`,
    phonePrefix: `+380`,
    daysToDeliver: `6`,
    shippingChargeCents: 10900,
  },
  AE: {
    name: `United Arab Emirates`,
    phonePrefix: `+971`,
    daysToDeliver: `4`,
    shippingChargeCents: 9800,
  },
  GB: {
    name: `United Kingdom`,
    phonePrefix: `+44`,
    daysToDeliver: `4`,
    shippingChargeCents: 9900,
    cityLabel: `Town`,
    stateWidth: 0,
    postalCodeMaxlen: 8,
    postalCodeLabel: `Postcode`,
    postalCodeWidth: 100,
    addressFieldOrder: [[`city`], [`postalCode`]],
    addressOptionalFields: [],
  },
  US: {
    name: `United States`,
    phonePrefix: `+1`,
    phoneMask: `(999) 999-9999`,
    daysToDeliver: `2-6`,
    shippingChargeCents: 995,
    cityLabel: `City`,
    cityWidth: 55,
    stateMaxlen: 2,
    stateLabel: `State`,
    stateWidth: 20,
    postalCodeLabel: `Zip Code`,
    postalCodeWidth: 25,
    postalCodeMask: `99999`,
    addressFieldOrder: [[`city`, `state`, `postalCode`]],
    addressOptionalFields: [],
    outboundShipperName: `USPS`,
    outboundServiceName: `First-class Mail`,
  },
  UM: {
    name: `United States Minor Outlying Islands`,
    daysToDeliver: `2-6`,
    shippingChargeCents: 995,
    carrierOk: false,
    cityLabel: `City`,
    cityWidth: 55,
    stateMaxlen: 2,
    stateLabel: `State`,
    stateWidth: 20,
    postalCodeLabel: `Zip Code`,
    postalCodeWidth: 25,
    postalCodeMask: `99999`,
    addressFieldOrder: [[`city`, `state`, `postalCode`]],
    addressOptionalFields: [],
    flagFilename: `US.png`,
    outboundShipperName: `USPS`,
    outboundServiceName: `First-class Mail`,
  },
  UY: {
    name: `Uruguay`,
    phonePrefix: `+598`,
    daysToDeliver: `5`,
    shippingChargeCents: 8100,
  },
  UZ: {
    name: `Uzbekistan`,
    phonePrefix: `+998`,
    daysToDeliver: `7`,
    shippingChargeCents: 10700,
  },
  VU: {
    name: `Vanuatu`,
    phonePrefix: `+678`,
    daysToDeliver: `6`,
    shippingChargeCents: 9500,
  },
  VE: {
    name: `Venezuela`,
    phonePrefix: `+58`,
    daysToDeliver: `4`,
    shippingChargeCents: 7200,
    ourGovtOk: false,
  },
  VN: {
    name: `Viet Nam`,
    phonePrefix: `+84`,
    daysToDeliver: `5`,
    shippingChargeCents: 7900,
  },
  VG: {
    name: `Virgin Islands, British`,
    phonePrefix: `+1`,
    daysToDeliver: `4`,
    shippingChargeCents: 6600,
    cityLabel: `Town`,
    stateWidth: 0,
    postalCodeMaxlen: 8,
    postalCodeLabel: `Postcode`,
    postalCodeWidth: 100,
    addressFieldOrder: [[`city`], [`postalCode`]],
    addressOptionalFields: [],
    flagFilename: `GB.png`,
  },
  VI: {
    name: `Virgin Islands, U.S.`,
    phonePrefix: `+1`,
    daysToDeliver: `2-6`,
    shippingChargeCents: 995,
    cityLabel: `City`,
    cityWidth: 55,
    stateMaxlen: 2,
    stateLabel: `State`,
    stateWidth: 20,
    postalCodeLabel: `Zip Code`,
    postalCodeWidth: 25,
    postalCodeMask: `99999`,
    addressFieldOrder: [[`city`, `state`, `postalCode`]],
    addressOptionalFields: [],
    flagFilename: `US.png`,
    outboundShipperName: `USPS`,
    outboundServiceName: `First-class Mail`,
  },
  WF: {
    name: `Wallis and Futuna`,
    phonePrefix: `+681`,
    daysToDeliver: `4`,
    shippingChargeCents: 6100,
    theirGovtOk: false,
    carrierOk: false,
    cityLabel: `Town Name and Sorting Code`,
    cityWidth: 70,
    stateWidth: 0,
    postalCodeMaxlen: 5,
    postalCodeWidth: 30,
    addressFieldOrder: [[`postalCode`, `city`]],
    addressOptionalFields: [],
    flagFilename: `FR.png`,
  },
  EH: {
    name: `Western Sahara`,
    carrierOk: false,
  },
  YE: {
    name: `Yemen`,
    phonePrefix: `+967`,
    daysToDeliver: `6`,
    shippingChargeCents: 9000,
    ourGovtOk: false,
  },
  ZM: {
    name: `Zambia`,
    phonePrefix: `+260`,
    daysToDeliver: `6`,
    shippingChargeCents: 12200,
  },
  ZW: {
    name: `Zimbabwe`,
    phonePrefix: `+263`,
    daysToDeliver: `5`,
    shippingChargeCents: 11400,
    ourGovtOk: false,
  },
  AX: {
    name: `Åland Islands`,
    phonePrefix: `+358`,
    daysToDeliver: `4`,
    shippingChargeCents: 9300,
    carrierOk: false,
    cityLabel: `Settlement`,
    cityWidth: 70,
    stateWidth: 0,
    postalCodeMaxlen: 5,
    postalCodeWidth: 30,
    addressFieldOrder: [[`postalCode`, `city`]],
    addressOptionalFields: [],
    flagFilename: `FI.png`,
  },
};

const defaultAddressFieldOrder = [[`city`], [`state`, `postalCode`]];

const defaultAddressOptionalFields = [`state`, `postalCode`];

export const getName = (countryCode: string): string => {
  return GEOGRAPHICAL_AREAS[countryCode]!.name;
};

export const getPhonePrefix = (countryCode: string): string | undefined => {
  return GEOGRAPHICAL_AREAS[countryCode]?.phonePrefix;
};

export const getPhoneMask = (countryCode: string): string | undefined => {
  return GEOGRAPHICAL_AREAS[countryCode]?.phoneMask;
};

export const getDaysToDeliver = (countryCode: string): string | undefined => {
  return GEOGRAPHICAL_AREAS[countryCode]?.daysToDeliver;
};

export const getShippingChargeCents = (countryCode: string): number | undefined => {
  return GEOGRAPHICAL_AREAS[countryCode]?.shippingChargeCents;
};

export const getOurGovtOk = (countryCode: string): boolean => {
  return GEOGRAPHICAL_AREAS[countryCode]?.ourGovtOk || true;
};

export const getTheirGovtOk = (countryCode: string): boolean => {
  return GEOGRAPHICAL_AREAS[countryCode]?.theirGovtOk || true;
};

export const getCarrierOk = (countryCode: string): boolean => {
  return GEOGRAPHICAL_AREAS[countryCode]?.carrierOk || true;
};

export const getCityMaxlen = (countryCode: string): number => {
  return GEOGRAPHICAL_AREAS[countryCode]?.cityMaxlen || 80;
};

export const getCityLabel = (countryCode: string): string => {
  return GEOGRAPHICAL_AREAS[countryCode]?.cityLabel || `City, Town, or Settlement`;
};

export const getCityWidth = (countryCode: string): number => {
  return GEOGRAPHICAL_AREAS[countryCode]?.cityWidth || 100;
};

export const getStateMaxlen = (countryCode: string): number => {
  return GEOGRAPHICAL_AREAS[countryCode]?.stateMaxlen || 50;
};

export const getStateLabel = (countryCode: string): string => {
  return GEOGRAPHICAL_AREAS[countryCode]?.stateLabel || `State, Province, or Region`;
};

export const getStateWidth = (countryCode: string): number => {
  return GEOGRAPHICAL_AREAS[countryCode]?.stateWidth || 60;
};

export const getPostalCodeMaxlen = (countryCode: string): number => {
  return GEOGRAPHICAL_AREAS[countryCode]?.postalCodeMaxlen || 10;
};

export const getPostalCodeLabel = (countryCode: string): string => {
  return GEOGRAPHICAL_AREAS[countryCode]?.postalCodeLabel || `Postal Code`;
};

export const getPostalCodeWidth = (countryCode: string): number => {
  return GEOGRAPHICAL_AREAS[countryCode]?.postalCodeWidth || 40;
};

export const getPostalCodeMask = (countryCode: string): string | undefined => {
  return GEOGRAPHICAL_AREAS[countryCode]?.postalCodeMask;
};

export const getAddressFieldOrder = (countryCode: string): string[][] => {
  return GEOGRAPHICAL_AREAS[countryCode]?.addressFieldOrder || defaultAddressFieldOrder;
};

export const getAddressOptionalFields = (countryCode: string): string[] => {
  return GEOGRAPHICAL_AREAS[countryCode]?.addressOptionalFields || defaultAddressOptionalFields;
};

export const getFlagFilename = (countryCode: string): string | undefined => {
  return GEOGRAPHICAL_AREAS[countryCode]?.flagFilename || `${countryCode}.png`;
};

export const getOutboundShipperName = (countryCode: string): string => {
  return GEOGRAPHICAL_AREAS[countryCode]?.outboundShipperName || `DHL`;
};

export const getOutboundServiceName = (countryCode: string): string => {
  return GEOGRAPHICAL_AREAS[countryCode]?.outboundServiceName || `Express Worldwide`;
};

export const getDeliveredDutyPaid = (countryCode: string): boolean => {
  return GEOGRAPHICAL_AREAS[countryCode]?.deliveredDutyPaid || false;
};

export const getTaxIdMaxlen = (countryCode: string): number | undefined => {
  return GEOGRAPHICAL_AREAS[countryCode]?.taxIdMaxlen;
};

export const getTaxIdLabel = (countryCode: string): string | undefined => {
  return GEOGRAPHICAL_AREAS[countryCode]?.taxIdLabel;
};

export const getTaxIdWidth = (countryCode: string): number | undefined => {
  return GEOGRAPHICAL_AREAS[countryCode]?.taxIdWidth;
};

export const getTaxIdMask = (countryCode: string): string | undefined => {
  return GEOGRAPHICAL_AREAS[countryCode]?.taxIdMask;
};

export const getFieldWidth = (countryCode: string, field?: string): number | undefined => {
  if (field === 'city') {
    return getCityWidth(countryCode);
  }
  if (field === 'state') {
    return getStateWidth(countryCode);
  }
  if (field === 'postalCode') {
    return getPostalCodeWidth(countryCode);
  }
  if (field === 'taxId') {
    return getTaxIdWidth(countryCode);
  }
  return undefined;
};

export const isCountryShippable = (countryCode: string): boolean => {
  return getOurGovtOk(countryCode) && getTheirGovtOk(countryCode) && getCarrierOk(countryCode);
};

export const hasAddressFieldForCountry = (countryCode: string, fieldName: string): boolean => {
  const fieldOrder = getAddressFieldOrder(countryCode);
  // fieldOrder is a nested array of the address fields for this country, so
  // we need to flatten them.
  const flattenedFields = [...(fieldOrder?.flat() || [])];
  return flattenedFields.indexOf(fieldName) !== -1;
};

export const isRequiredFieldForCountryAddress = (
  countryCode: string,
  fieldName: string
): boolean => {
  const optionalFields = getAddressOptionalFields(countryCode);
  return (optionalFields || []).indexOf(fieldName) === -1;
};

export const ALL_COUNTRIES: string[] = Object.keys(GEOGRAPHICAL_AREAS)
  .filter((countryCode) => {
    return getOurGovtOk(countryCode) && getCarrierOk(countryCode);
  })
  .sort((a, b) => {
    return getName(a).localeCompare(getName(b));
  });

export const PHONE_COUNTRIES: string[] = Object.keys(GEOGRAPHICAL_AREAS)
  .filter((countryCode) => {
    return getPhonePrefix(countryCode);
  })
  .sort((a, b) => {
    return getName(a).localeCompare(getName(b));
  });
